module.exports = __webpack_public_path__ + "static/media/3.6c8681b3.jpg";